<template>
  <div class="row">
    <div class="col-12 mb-3 lang-selector">
      <select v-model="selectedLang" class="lang-selector__dropdown form-control mb-2">
        <option v-for="lang in langs" :key="lang.code" :value="lang">{{ lang.code }}</option>
      </select>
    </div>

    <card-update-page
      :key="pageUpdates"
      :page="page"
      :inProgress="inProgress"
      :lang="selectedLang.code"
      :dir="selectedLang.rtl ? 'rtl' : 'ltr'"
    ></card-update-page>

    <card-update-tags
      v-if="['place'].indexOf(page.type) !== -1"
      :page="page"
      :triggerSliderRefresh="triggerSliderRefresh"
      :lang="selectedLang.code"
      :dir="selectedLang.rtl ? 'rtl' : 'ltr'"
    ></card-update-tags>

    <card-update-interactive-tags
      v-if="['interactiveTags'].indexOf(page.type) !== -1"
      :page="page"
      :triggerSliderRefresh="triggerSliderRefresh"
      :lang="selectedLang.code"
      :dir="selectedLang.rtl ? 'rtl' : 'ltr'"
    />
    
    <div class="col-12">
      <button
        :disabled="inProgress"
        @click="updatePage(page._id)"
        class="btn btn-primary"
        type="button"
      >
        Update Page
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import { 
  FETCH_ASSET,
  FETCH_PAGE,
  PAGE_EDIT,
  PAGE_PUBLISH
} from "@/store/actions.type"
import CardUpdatePage from '@/pages/PageEdit/CardUpdatePage'
import CardUpdateTags from '@/pages/PageEdit/CardUpdateTags'
import CardUpdateInteractiveTags from '@/pages/PageEdit/CardUpdateInteractiveTags'
import _ from 'lodash'


export default {

  name: "PagesView",

  components: {
    CardUpdatePage,
    CardUpdateTags,
    CardUpdateInteractiveTags
  },

  data() {
    return {
      initialPageJSON: null,
      inProgress: false,
      deselectActiveTag: false,

      modalContext: '',
      modalData: {
        asset: {},
        assetSelected: {
          content: {}
        }
      },

      pageUpdates: 0,
      selectedLang: {code: "en", rtl: false},
      triggerSliderRefresh: false,
    };
  },

  computed: {
    ...mapGetters([
      "page",
      "langs"
    ]),

    currentPageJSON () {
      return JSON.stringify(this.page)
    },

    isPageChanged () {
      return this.currentPageJSON !== this.initialPageJSON
    },

    tagBasic: function() {
      return this.page.tags.filter(function(tag) {
        return tag.type == "basic";
      });
    },

    tagRich: function() {
      return this.page.tags.filter(function(tag) {
        return tag.type == "rich";
      });
    },

    tagBox: function() {
      return this.page.tags.filter(function(tag) {
        return tag.type == "box";
      });
    },

    tagRef: function() {
      let refTags = this.page.tags.filter(function(tag) {
        return tag.type == "reference";
      });

      return _.orderBy(refTags, ['pos.x'])
    }
  },

  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch(FETCH_PAGE, to.params.id)]).then(() => {
      next();
    });
  },

  beforeRouteLeave(to, from, next) {
    if (this.isPageChanged) {
      if (window.confirm('Warning! Unsaved changes. Do you really want to leave?')) { 
        next()
      }
    } else {
      next()
    }
  },

  mounted () {
    this.selectedLang = this.langs[0]
    this.initialPageJSON = JSON.stringify(this.page)
  },

  methods: {
    updatePage(id) {
      this.deselectActiveTag = true
      this.inProgress = true
      this.$store
        .dispatch(PAGE_EDIT, this.page)
        .then(({ data }) => {
          this.inProgress = false;
          this.triggerSliderRefresh = !this.triggerSliderRefresh
          this.initialPageJSON = JSON.stringify(this.page)
          this.pageUpdates++
        })
        .catch(err => {
          this.inProgress = false;
          this.triggerSliderRefresh = !this.triggerSliderRefresh
        });
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";

.form-preview-image {
  max-width: 300px;
  width: 100%;
}

.preview {
  font-size: 30px;
}

.card-update-page {
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;

  @media (min-width: 1950px) {
    width: 50%;
  }
}

.lang-selector {
  pointer-events: none;
  position: sticky;
  top: 16px;
  z-index: 100;

  &__dropdown {
    box-shadow: 
      0 0px 2.2px rgba(0, 0, 0, 0.028),
      0 0px 5.3px rgba(0, 0, 0, 0.04),
      0 0px 10px rgba(0, 0, 0, 0.05),
      0 0px 17.9px rgba(0, 0, 0, 0.06),
      0 0px 33.4px rgba(0, 0, 0, 0.072),
      0 0px 80px rgba(0, 0, 0, 0.1);
    margin: 0 20px 0 auto;
    pointer-events: auto;
    width: auto;

    &:focus {
      box-shadow: 
        0 0px 2.2px rgba(0, 0, 0, 0.028),
        0 0px 5.3px rgba(0, 0, 0, 0.04),
        0 0px 10px rgba(0, 0, 0, 0.05),
        0 0px 17.9px rgba(0, 0, 0, 0.06),
        0 0px 33.4px rgba(0, 0, 0, 0.072),
        0 0px 80px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
